import { render, staticRenderFns } from "./DashboardSellStats.vue?vue&type=template&id=06c73f71&"
import script from "./DashboardSellStats.vue?vue&type=script&lang=js&"
export * from "./DashboardSellStats.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSellStats.vue?vue&type=style&index=0&id=06c73f71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports